import { useEffect } from 'react';

const useInfiniteScroll = (
  loadMore: () => void,
  isLoadingMore: boolean,
  isReachingEnd: boolean,
) => {
  useEffect(() => {
    const trigger = document.getElementById('infinite-scroll-trigger');
    if (!trigger) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isLoadingMore && !isReachingEnd) {
          loadMore();
        }
      },
      { threshold: 0.7 },
    );

    observer.observe(trigger);
    return () => {
      observer.unobserve(trigger);
    };
  }, [isLoadingMore, isReachingEnd, loadMore]);
};

export default useInfiniteScroll;
